import React, { useEffect, useState } from "react";
import { Box, Heading, Table, Thead, Tbody, Tr, Th, Td, Switch, Select, HStack, useToast, Text, Button } from "@chakra-ui/react";
import client from "../../../helpers/Client";

const ROLES = [
  { value: "manager", label: "Yönetici" },
  { value: "servicer", label: "Servisçi" },
  { value: "technical", label: "Teknik" },
  { value: "reseller", label: "Bayi" },
  { value: "employee", label: "Personel" },
];

const SECTIONS = [
  { to: "/ana-sayfa/", title: "Ana Sayfa" },
  { to: "/calisanlar/", title: "Personellar" },
  { to: "/musteriler/", title: "Müşteriler" },
  { to: "/proje/", title: "Projeler" },
  { to: "/bayi/", title: "Bayi" },
  { to: "/is-emri/", title: "İş Emri" },
  { to: "/tamamlanmis-is-emri/", title: "Tamamlanmış İş Emri" },
  { to: "/gorevler/", title: "Görevler" },
  { to: "/randevular/", title: "Randevular" },
  { to: "/servis/", title: "Servis Kayıtları" },
  { to: "/is-emri/olustur/", title: "Yeni İş Emri" },
];

export default function RolePagesMatrix() {
  const toast = useToast();
  const [data, setData] = useState([]); // raw role-pages entries
  const [role, setRole] = useState("manager");
  const [loading, setLoading] = useState(true);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const { data } = await client.get(`/config/role-pages/?enabled=false`);
      const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
      setData(arr);
    } catch (e) {
      toast({ title: "Veri alınamadı", status: "error" });
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchAll(); }, []);

  const isDisabled = (roleCode, route) => {
    return data.some(d => d.role_code === roleCode && d.route === route && d.enabled === false);
  };

  const toggle = async (roleCode, route, next) => {
    try {
      const existing = data.find(d => d.role_code === roleCode && d.route === route);
      if (next) {
        // Açık: deny kaydı varsa sil
        if (existing) {
          await client.delete(`/config/role-pages/${existing.id}/`);
        }
      } else {
        // Kapalı: deny kaydı yoksa oluştur, varsa patch
        if (!existing) {
          await client.post(`/config/role-pages/`, { role_code: roleCode, route, label: "", enabled: false });
        } else {
          await client.patch(`/config/role-pages/${existing.id}/`, { enabled: false });
        }
      }
      toast({ title: next ? "Açıldı" : "Kapatıldı", status: "success" });
      fetchAll();
    } catch (e) {
      toast({ title: "Güncelleme hatası", status: "error" });
    }
  };

  return (
    <Box p={6}>
      <Heading size="md" mb={3}>Rol Matrisini Yönet</Heading>
      <Text color="gray.600" mb={4}>Varsayılan: tüm sayfalar açık. Kapattığınız kombinasyonlar o rolde gizlenir.</Text>
      <HStack mb={4}>
        <Select value={role} onChange={(e) => setRole(e.target.value)} w="220px">
          {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
        </Select>
        <Button onClick={fetchAll} isLoading={loading}>Yenile</Button>
      </HStack>
      <Table size="sm" variant="simple">
        <Thead>
          <Tr>
            <Th>Sayfa</Th>
            <Th>Route</Th>
            <Th>Durum ({ROLES.find(r => r.value === role)?.label})</Th>
          </Tr>
        </Thead>
        <Tbody>
          {SECTIONS.map(sec => {
            const disabled = isDisabled(role, sec.to);
            const checked = !disabled;
            return (
              <Tr key={sec.to}>
                <Td>{sec.title}</Td>
                <Td>{sec.to}</Td>
                <Td>
                  <Switch isChecked={checked} onChange={(e) => toggle(role, sec.to, e.target.checked)} />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
}